import { render } from "./CompMobileKeyboard.vue?vue&type=template&id=7015cf6a"
import script from "./CompMobileKeyboard.vue?vue&type=script&lang=js"
export * from "./CompMobileKeyboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__